const getFarmFromNucleus = nucleus =>
  nucleus && nucleus.cooperatives
    ? nucleus.cooperatives.reduce(
        (a, b) => a.concat(b.farms.map(f => ({ ...f, cooperativeName: b.name }))),
        [],
      )
    : []

export default { getFarmFromNucleus }
